<div class="bg-container"></div>
<div class="container-fluid bg-img">
  <div class="form-card">

    <div class="form-bg row">
      <div class="col-6 p-0">
        <div class="text-center h-100">
          <img class="logo" src="../../../../assets/Logo.svg" alt="logo" />
        </div>
       
      </div>
      <div class="col-6 d-flex justify-content-end align-items-center">
        <!-- <div *ngIf="!isAutoLogin">
          <button type="button" class="btn botton" (click)="preLogin()">Login</button>
        </div> -->
  </div>
      <!-- <div class="col-7 px-4 py-3 text-center">
        <p class="login-header">Login</p>
        <form class="form-field" #loginForm="ngForm">
          <div class="form-group">
            <input type="text" name="email" [(ngModel)]="email" placeholder="Email ID" class="form-control" required />
          </div>
          <div class="form-group">
            <input type="password" name="password" [(ngModel)]="password" placeholder="Password" class="form-control"
              required />
          </div>
          <br />
          <div class="form-linkbutton d-flex justify-content-between mt-2">
            <a [routerLink]="['/auth/forgot-password']" class="fpasswordlink align-self-center">Forgot Password?</a>
            <button type="submit" class="btn botton" (click)="applogin()">
              Login
            </button>
          </div>
        </form>
      </div> -->

    </div>
    

  </div>
</div>